import { Link, useLocation } from 'react-router-dom';
import { BookOpen, House, Landmark, Plane, WalletCards } from 'lucide-react';
import { LIFE_HACKS_PATH } from './Header';

const TABS = [
  { to: '/', label: 'Home', icon: House },
  { to: '/guides', label: 'Guides', icon: BookOpen },
  { to: LIFE_HACKS_PATH, label: 'Moving', icon: Plane },
  { to: '/remittance', label: 'Money', icon: WalletCards },
  { to: '/about', label: 'About', icon: Landmark },
] as const;

export default function BottomNav() {
  const location = useLocation();

  const isActive = (to: (typeof TABS)[number]['to']) => {
    if (to === '/') return location.pathname === '/';
    if (to === LIFE_HACKS_PATH) {
      return location.pathname === '/guides' && location.search.includes('category=life');
    }
    if (to === '/guides') {
      return location.pathname.startsWith('/guides') && !location.search.includes('category=life');
    }
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="safe-bottom fixed inset-x-0 bottom-0 z-50 border-t border-ink-200 bg-white dark:border-surface-dark-border dark:bg-surface-dark lg:hidden" aria-label="Mobile navigation">
      <div className="flex h-16 items-center justify-around px-1">
        {TABS.map(({ to, label, icon: Icon }) => {
          const active = isActive(to);
          return (
            <Link
              key={to}
              to={to}
              aria-current={active ? 'page' : undefined}
              className={`flex h-full flex-1 flex-col items-center justify-center gap-0.5 transition-colors ${
                active ? 'text-jeok-500' : 'text-ink-400 dark:text-ink-500'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-[10px] font-medium leading-tight">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
